module.exports = __webpack_public_path__ + "media/images/weather/10_day_g-5ed5dc51623b0252f56d5e9453cf27da.png";